import {
    DETAILS_RECIEVED,
} from '../../youwell-common/ReduxStoreHelper';


export const PROGRAM_ACTION_PREFIX = 'PROGRAM';
export const TASKRESPONSE_INSERTED = 'TASKRESPONSE_INSERTED';
export const PROGRAM_TASKRESPONSE_INSERTED = `${PROGRAM_ACTION_PREFIX}/${TASKRESPONSE_INSERTED}`;
export const RESPONSES_RECEIVED = 'RESPONSES_RECEIVED';
export const CURRENTPROGRAM_RECEIVED = 'CURRENTPROGRAM_RECEIVED';

export const PROGRAM_RESPONSES_RECEIVED = `${PROGRAM_ACTION_PREFIX}/${RESPONSES_RECEIVED}`;
export const PROGRAM_CURRENTPROGRAM_RECEIVED = `${PROGRAM_ACTION_PREFIX}/${CURRENTPROGRAM_RECEIVED}`;

export const USER_ACTION_PREFIX = 'USER';
export const SENSOR_DELETED = 'SENSOR_DELETED';
export const USER_SENSOR_DELETED = `${USER_ACTION_PREFIX}/${SENSOR_DELETED}`;
export const SUCCESS_UPLOAD_PROFILEIMAGE = 'SUCCESS_UPLOAD_PROFILEIMAGE';
export const USER_UPLOAD_PROFILEIMAGE = `${USER_ACTION_PREFIX}/${SUCCESS_UPLOAD_PROFILEIMAGE}`;
const SUCCESS_DELETE_PROFILEIMAGE = 'SUCCESS_DELETE_PROFILEIMAGE';
export const USER_DELETE_PROFILEIMAGE = `${USER_ACTION_PREFIX}/${SUCCESS_DELETE_PROFILEIMAGE}`;

export const PUBLIC_ACTION_PREFIX = 'PUBLIC';
export const PUBLIC_PROGRAM_RECEIVED = `${PUBLIC_ACTION_PREFIX}/${DETAILS_RECIEVED}`;

export const PREVIEW_ACTION_PREFIX = 'PREVIEW';
export const PREVIEW_TASK_RECEIVED = `${PREVIEW_ACTION_PREFIX}/${DETAILS_RECIEVED}`;

export const AUTH_ACTION_PREFIX = 'AUTH';
export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const AUTH_SUCCESS_LOGIN = `${AUTH_ACTION_PREFIX}/${SUCCESS_LOGIN}`;
